import { Box, SkeletonGroup, SkeletonRectangle, Text } from '@wix/design-system';
import React from 'react';
export const HeadingStructureRuleHeader = _ref => {
  let {
    headingDefinition,
    headingContent,
    status,
    isLoading
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    gap: "SP2"
  }, isLoading ? /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    height: "30px",
    width: "30px"
  }, /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    height: "30px",
    width: "30px"
  }))) : /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    minWidth: "30px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    skin: !status ? 'error' : undefined,
    weight: "bold"
  }, headingDefinition ?? 'p')), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    ellipsis: true,
    maxLines: 2,
    size: "tiny",
    tooltipProps: {
      appendTo: 'window'
    },
    weight: "normal"
  }, headingContent)));
};
//# sourceMappingURL=heading-structure-rule-header.js.map